module.exports = __webpack_public_path__ + "img/Zabbix.7a686f9.svg";